import { render, staticRenderFns } from "./TAnswerSeoEn.vue?vue&type=template&id=1700783d&"
import script from "./TAnswerSeoEn.vue?vue&type=script&lang=js&"
export * from "./TAnswerSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports